import {axiosInstance as mantis} from "src/api/mantis";

export const getOrganizationDetails = organizationId => {
    return mantis.get(`/organisation/${organizationId}`, {
        cache: {
            maxAge: 2 * 60 * 60 * 1000
        }
    });
};

export const getOrganisations = (tenantId, query, page, limit, sortBy, sortDir) => {
    const params = {
        parentTenantId: tenantId,
        name: query.name,
        organisationType: query.organisationType,
        providerOrderId: query.providerOrderId,
        status: query.status,
        pageNumber: page + 1,
        pageSize: limit,
        sortBy: sortBy,
        sortDirection: sortDir
    };

    const config = {params: params};
    return mantis.get("/organisation", config);
};

export const createOrganisation = (tenantId, values) => {
    const data = {
        type: values.type,
        parentTenantId: tenantId,
        organization: {
            organization: values.organization,
            addressLine: values.addressLine,
            postalCode: values.postalCode,
            locality: clearData(values.locality),
            state: values.state,
            country: values.country,
            phone: clearData(values.phone),
            emailAddress: clearData(values.emailAddress),
            jurisdictionCity: clearData(values.jurisdictionCity),
            jurisdictionState: clearData(values.jurisdictionState),
            jurisdictionCountry: clearData(values.jurisdictionCountry)
        },
        adminContact: {
            title: values.adminTitle,
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            phone: clearData(values.phone)
        }
    };

    return mantis.post("/organisation", data);
};

export const renewOrganisations = (organizationId, tenantId, values) => {
    const data = {
        type: values.type,
        parentTenantId: tenantId,
        organization: {
            organization: values.organization,
            addressLine: values.addressLine,
            postalCode: values.postalCode,
            locality: clearData(values.locality),
            state: values.state,
            country: values.country,
            phone: clearData(values.phone),
            emailAddress: clearData(values.emailAddress),
            jurisdictionCity: clearData(values.jurisdictionCity),
            jurisdictionState: clearData(values.jurisdictionState),
            jurisdictionCountry: clearData(values.jurisdictionCountry)
        },
        adminContact: {
            title: values.adminTitle,
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            phone: clearData(values.phone)
        }
    };

    return mantis.patch(`/organisation/${organizationId}`, data);
};

export const getOrganisationsUserPortal = (organisationId) => {
    return mantis.get("/organisation/" + organisationId + "/provider/userPortal");
};

const clearData = (data) => {
    return data ? data : null;
}